module.exports = __webpack_public_path__ + "components/flag/static/square/ax-9f315b71fc51b495dc4b30899f27da8e.svg";